import React from "react";
import styled from "styled-components";
import Tooltip from "rc-tooltip";
import "rc-tooltip/assets/bootstrap.css";
import data from "./data";
import Container from "../../UI/Layout/Container";
import Grid from "../../UI/Layout/Grid";
import Box from "../../UI/Layout/Box";
import Sidepanel from "../../UI/Sidepanel/Sidepanel";
import Footer from "../../UI/Footer/Footer";
import Filters from "../../UI/Filters/Filters";
//import ReactMapGL, { Marker, NavigationControl } from "react-map-gl";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import icon from "@fortawesome/fontawesome-free-solid/faCircle";
import faCheckSquare from "@fortawesome/fontawesome-free-solid/faCheckSquare";
import faClose from "@fortawesome/fontawesome-free-solid/faAngleRight";
import faLibrary from "@fortawesome/fontawesome-free-solid/faThLarge";
import faMap from "@fortawesome/fontawesome-free-solid/faMapMarkerAlt";
import Shell from "../../UI/Templates/Shell";
import Item from "../../UI/Item/Item";
import Search from "../../UI/Search/Search";
import Button from "../../UI/Button/Button";
import ButtonGroup from "../../UI/Button/ButtonGroup";
import Map from "../../UI/Map/Map";

const FILTERS = [
  {
    name: "Filters",
    properties: [
      { name: "Organization", size: 7 },
      { name: "Project / Activity", size: 16 }
    ]
  },
  {
    name: "Status",
    properties: [
      { name: "Ongoing project", size: 6 },
      { name: "Past project", size: 10 }
    ]
  },
  {
    name: "Date",
    properties: [{ name: "Calendar + timebar", size: 1 }]
  },
  {
    name: "Themes",
    properties: [
      { name: "Torture & ill-treatment ", size: 1 },
      { name: "Punishment", size: 1 },
      { name: "Interrogations", size: 1 },
      { name: "Complaints", size: 1 },
      { name: "Impunity", size: 1 },
      { name: "Non-refoulement", size: 1 },
      { name: "Remedy & reparation/rehabilitation", size: 1 },
      { name: "Legal safeguards", size: 1 },
      { name: "Detention", size: 1 },
      { name: "Conditions and treatment in detention", size: 1 },
      { name: "Detention Monitoring", size: 1 },
      { name: "Alternative measures to detention", size: 1 },
      { name: "Root causes of torture & ill-treatment", size: 1 },
      { name: "Reprisals", size: 1 },
      { name: "Training ", size: 1 }
    ]
  },
  {
    name: "Source",
    properties: [
      { name: "Academia", size: 1 },
      { name: "Civil society", size: 1 },
      {
        name: "National body",
        size: 1,
        children: [{ name: "NPM", size: 1 }, { name: "NHRI", size: 1 }]
      },
      {
        name: "Regional body",
        size: 1,
        children: [{ name: "CPT", size: 1 }, { name: "ECtHR", size: 1 }]
      },
      {
        name: "UN body",
        size: 1,
        children: [
          { name: "CAT Committee", size: 1 },
          { name: "SPT", size: 1 },
          { name: "SRT", size: 1 }
        ]
      }
    ]
  },
  {
    name: "Location",
    properties: [
      {
        name: "Africa",
        size: 1,
        children: [
          { name: "Algeria", size: 1 },
          { name: "Angola", size: 1 },
          { name: "Benin", size: 1 },
          { name: "Botswana", size: 1 },
          { name: "Burkina Faso", size: 1 },
          { name: "Burundi", size: 1 },
          { name: "Cameroon", size: 1 },
          { name: "Cape Verde", size: 1 },
          { name: "Central African Republic", size: 1 },
          { name: "Chad", size: 1 },
          { name: "Comoros", size: 1 },
          { name: "Democratic Republic of the Congo", size: 1 },
          { name: "Djibouti", size: 1 },
          { name: "Egypt", size: 1 },
          { name: "Equatorial Guinea", size: 1 },
          { name: "Eritrea", size: 1 },
          { name: "Ethiopia", size: 1 },
          { name: "Gabon", size: 1 },
          { name: "Gambia", size: 1 },
          { name: "Ghana", size: 1 },
          { name: "Guinea", size: 1 },
          { name: "Guinea-Bissau", size: 1 },
          { name: "Ivory Coast", size: 1 },
          { name: "Kenya", size: 1 },
          { name: "Lesotho", size: 1 },
          { name: "Liberia", size: 1 },
          { name: "Libya", size: 1 },
          { name: "Madagascar", size: 1 },
          { name: "Malawi", size: 1 },
          { name: "Mali", size: 1 },
          { name: "Mauritania", size: 1 },
          { name: "Mauritius", size: 1 },
          { name: "Mayotte", size: 1 },
          { name: "Morocco", size: 1 },
          { name: "Mozambique", size: 1 },
          { name: "Namibia", size: 1 },
          { name: "Niger", size: 1 },
          { name: "Nigeria", size: 1 },
          { name: "Republic of the Congo", size: 1 },
          { name: "Réunion", size: 1 },
          { name: "Rwanda", size: 1 },
          { name: "Saint Helena", size: 1 },
          { name: "São Tomé and Príncipe", size: 1 },
          { name: "Senegal", size: 1 },
          { name: "Seychelles", size: 1 },
          { name: "Sierra Leone", size: 1 },
          { name: "Somalia", size: 1 },
          { name: "South Africa", size: 1 },
          { name: "South Sudan", size: 1 },
          { name: "Sudan", size: 1 },
          { name: "Swaziland", size: 1 },
          { name: "Tanzania", size: 1 },
          { name: "Togo", size: 1 },
          { name: "Tunisia", size: 1 },
          { name: "Uganda", size: 1 },
          { name: "Western Sahara", size: 1 },
          { name: "Zambia", size: 1 },
          { name: "Zimbabwe", size: 1 }
        ]
      },
      {
        name: "Antartica",
        size: 1,
        children: [
          { name: "Antartica", size: 1 },
          { name: "Bouvet Island", size: 1 },
          { name: "French Southern Territories", size: 1 },
          { name: "Heard Island and McDonald Islands", size: 1 },
          { name: "South Georgia and the South Sandwich Islands", size: 1 }
        ]
      },
      {
        name: "Asia",
        size: 1,
        children: [
          { name: "Afghanistan", size: 1 },
          { name: "Armenia", size: 1 },
          { name: "Azerbaijan", size: 1 },
          { name: "Bahrain", size: 1 },
          { name: "Bangladesh", size: 1 },
          { name: "Bhutan", size: 1 },
          { name: "British Indian Ocean Territory", size: 1 },
          { name: "Brunei", size: 1 },
          { name: "Cambodia", size: 1 },
          { name: "China", size: 1 },
          { name: "Christmas Island", size: 1 },
          { name: "Cocos [Keeling] Islands", size: 1 },
          { name: "Georgia", size: 1 },
          { name: "Hong Kong", size: 1 },
          { name: "India", size: 1 },
          { name: "Indonesia", size: 1 },
          { name: "Iran", size: 1 },
          { name: "Iraq", size: 1 },
          { name: "Israel", size: 1 },
          { name: "Japan", size: 1 },
          { name: "Jordan", size: 1 },
          { name: "Kazakhstan", size: 1 },
          { name: "Kuwait", size: 1 },
          { name: "Kyrgyzstan", size: 1 },
          { name: "Laos", size: 1 },
          { name: "Lebanon", size: 1 },
          { name: "Macao", size: 1 },
          { name: "Malaysia", size: 1 },
          { name: "Maldives", size: 1 },
          { name: "Mongolia", size: 1 },
          { name: "Myanmar [Burma]", size: 1 },
          { name: "Nepal", size: 1 },
          { name: "North Korea", size: 1 },
          { name: "Oman", size: 1 },
          { name: "Pakistan", size: 1 },
          { name: "Palestine", size: 1 },
          { name: "Philippines", size: 1 },
          { name: "Qatar", size: 1 },
          { name: "Saudi Arabia", size: 1 },
          { name: "Singapore", size: 1 },
          { name: "South Korea", size: 1 },
          { name: "Sri Lanka", size: 1 },
          { name: "Syria", size: 1 },
          { name: "Taiwan", size: 1 },
          { name: "Tajikistan", size: 1 },
          { name: "Thailand", size: 1 },
          { name: "Turkey", size: 1 },
          { name: "Turkmenistan", size: 1 },
          { name: "United Arab Emirates", size: 1 },
          { name: "Uzbekistan", size: 1 },
          { name: "Vietnam", size: 1 },
          { name: "Yemen", size: 1 }
        ]
      },
      {
        name: "Europe",
        size: 1,
        children: [
          { name: "Åland", size: 1 },
          { name: "Albania", size: 1 },
          { name: "Andorra", size: 1 },
          { name: "Austria", size: 1 },
          { name: "Belarus", size: 1 },
          { name: "Belgium", size: 1 },
          { name: "Bosnia and Herzegovina", size: 1 },
          { name: "Bulgaria", size: 1 },
          { name: "Croatia", size: 1 },
          { name: "Cyprus", size: 1 },
          { name: "Czech Republic", size: 1 },
          { name: "Denmark", size: 1 },
          { name: "Estonia", size: 1 },
          { name: "Faroe Islands", size: 1 },
          { name: "Finland", size: 1 },
          { name: "France", size: 1 },
          { name: "Germany", size: 1 },
          { name: "Gibraltar", size: 1 },
          { name: "Greece", size: 1 },
          { name: "Guernsey", size: 1 },
          { name: "Hungary", size: 1 },
          { name: "Iceland", size: 1 },
          { name: "Ireland", size: 1 },
          { name: "Isle of Man", size: 1 },
          { name: "Italy", size: 1 },
          { name: "Jersey", size: 1 },
          { name: "Kosovo", size: 1 },
          { name: "Latvia", size: 1 },
          { name: "Liechtenstein", size: 1 },
          { name: "Lithuania", size: 1 },
          { name: "Luxembourg", size: 1 },
          { name: "Macedonia", size: 1 },
          { name: "Malta", size: 1 },
          { name: "Moldova", size: 1 },
          { name: "Monaco", size: 1 },
          { name: "Montenegro", size: 1 },
          { name: "Netherlands", size: 1 },
          { name: "Norway", size: 1 },
          { name: "Poland", size: 1 },
          { name: "Portugal", size: 1 },
          { name: "Romania", size: 1 },
          { name: "Russia", size: 1 },
          { name: "San Marino", size: 1 },
          { name: "Serbia", size: 1 },
          { name: "Slovakia", size: 1 },
          { name: "Slovenia", size: 1 },
          { name: "Spain", size: 1 },
          { name: "Svalbard and Jan Mayen", size: 1 },
          { name: "Sweden", size: 1 },
          { name: "Switzerland", size: 1 },
          { name: "Ukraine", size: 1 },
          { name: "United Kingdom", size: 1 },
          { name: "Vatican City", size: 1 }
        ]
      },
      {
        name: "North America",
        size: 1,
        children: [
          { name: "Anguilla", size: 1 },
          { name: "Antigua and Barbuda", size: 1 },
          { name: "Aruba", size: 1 },
          { name: "Bahamas", size: 1 },
          { name: "Barbados", size: 1 },
          { name: "Belize", size: 1 },
          { name: "Bermuda", size: 1 },
          { name: "Bonaire", size: 1 },
          { name: "British Virgin Islands", size: 1 },
          { name: "Canada", size: 1 },
          { name: "Cayman Islands", size: 1 },
          { name: "Costa Rica", size: 1 },
          { name: "Cuba", size: 1 },
          { name: "Curacao", size: 1 },
          { name: "Dominica", size: 1 },
          { name: "Dominican Republic", size: 1 },
          { name: "El Salvador", size: 1 },
          { name: "Greenland", size: 1 },
          { name: "Grenada", size: 1 },
          { name: "Guadeloupe", size: 1 },
          { name: "Guatemala", size: 1 },
          { name: "Haiti", size: 1 },
          { name: "Honduras", size: 1 },
          { name: "Jamaica", size: 1 },
          { name: "Martinique", size: 1 },
          { name: "Mexico", size: 1 },
          { name: "Montserrat", size: 1 },
          { name: "Nicaragua", size: 1 },
          { name: "Panama", size: 1 },
          { name: "Puerto Rico", size: 1 },
          { name: "Saint Barthélemy", size: 1 },
          { name: "Saint Kitts and Nevis", size: 1 },
          { name: "Saint Lucia", size: 1 },
          { name: "Saint Martin", size: 1 },
          { name: "Saint Pierre and Miquelon", size: 1 },
          { name: "Saint Vincent and the Grenadines", size: 1 },
          { name: "Sint Maarten", size: 1 },
          { name: "Trinidad and Tobago", size: 1 },
          { name: "Turks and Caicos Islands", size: 1 },
          { name: "U.S. Virgin Islands", size: 1 },
          { name: "United States", size: 1 }
        ]
      },
      {
        name: "Oceania",
        size: 1,
        children: [
          { name: "American Samoa", size: 1 },
          { name: "Australia", size: 1 },
          { name: "Cook Islands", size: 1 },
          { name: "East Timor", size: 1 },
          { name: "Fiji", size: 1 },
          { name: "French Polynesia", size: 1 },
          { name: "Guam", size: 1 },
          { name: "Kiribati", size: 1 },
          { name: "Marshall Islands", size: 1 },
          { name: "Micronesia", size: 1 },
          { name: "Nauru", size: 1 },
          { name: "New Caledonia", size: 1 },
          { name: "New Zealand", size: 1 },
          { name: "Niue", size: 1 },
          { name: "Norfolk Island", size: 1 },
          { name: "Northern Mariana Islands", size: 1 },
          { name: "Palau", size: 1 },
          { name: "Papua New Guinea", size: 1 },
          { name: "Pitcairn Islands", size: 1 },
          { name: "Samoa", size: 1 },
          { name: "Solomon Islands", size: 1 },
          { name: "Tokelau", size: 1 },
          { name: "Tonga", size: 1 },
          { name: "Tuvalu", size: 1 },
          { name: "U.S. Minor Outlying Islands", size: 1 },
          { name: "Vanuatu", size: 1 },
          { name: "Wallis and Futuna", size: 1 }
        ]
      },
      {
        name: "South America",
        size: 1,
        children: [
          { name: "Argentina", size: 1 },
          { name: "Bolivia", size: 1 },
          { name: "Brazil", size: 1 },
          { name: "Chile", size: 1 },
          { name: "Colombia", size: 1 },
          { name: "Ecuador", size: 1 },
          { name: "Falkland Islands", size: 1 },
          { name: "French Guiana", size: 1 },
          { name: "Guyana", size: 1 },
          { name: "Paraguay", size: 1 },
          { name: "Peru", size: 1 },
          { name: "Suriname", size: 1 },
          { name: "Uruguay", size: 1 },
          { name: "Venezuela", size: 1 }
        ]
      }
    ]
  },
  {
    name: "Groups",
    properties: [
      { name: "Children", size: 1 },
      { name: "Detainee", size: 1 },
      { name: "Drug users", size: 1 },
      { name: "Elderly persons", size: 1 },
      { name: "Minorities", size: 1 },
      { name: "Human rights defenders", size: 1 },
      { name: "Law enforcement personnel ", size: 1 },
      { name: "LGBTI", size: 1 },
      { name: "Life-sentenced prisoners", size: 1 },
      { name: "Medical personnel", size: 1 },
      { name: "Migrants/refugees & asylum seekers", size: 1 },
      { name: "Non-state agents", size: 1 },
      { name: "Persons living with HIV/AIDs", size: 1 },
      { name: "Persons with disabilities", size: 1 },
      { name: "Relatives of victims of human rights violations", size: 1 },
      { name: "Stateless persons", size: 1 },
      { name: "Victims of trafficking", size: 1 },
      { name: "Victims of torture and ill-treatment", size: 1 },
      { name: "Victims of violence / SGBV", size: 1 },
      { name: "Women and girls", size: 1 }
    ]
  }
];

export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      instance: data.instance,
      navbar: {
        instance: "aot",
        logoAlt: "Atlas of Torture",
        logo: "/aot-logo.png",
        links: [
          { title: "Home", url: "/" },
          { title: "About us" },
          { title: "Database" },
          {
            title: "Projects & Activities",
            url:
              "/projects?access_token=pk.eyJ1IjoiZGFuaWNhdGFsYW4iLCJhIjoiY2o4eWVybGJxMXViYjJwcWNyZ3poa3NqcyJ9.mWTnxEb_B2h_x11wdtwFeQ"
          },
          { title: "Learning", url: "/learning" },
          { title: "Exchange", url: "/exchange/1" },
          { title: "Contact" }
        ]
      },
      sidepanel: [],
      viewport: props.viewport
    };
    this.clickOnMarker = this.clickOnMarker.bind(this);
    this.clickOnCluster = this.clickOnCluster.bind(this);
    this.clickOnViewButton = this.clickOnViewButton.bind(this);
  }
  getMarkers() {
    let temp = [];
    data.projects.map((project, i) =>
      project.metadata.loc.map(location =>
        temp.push({
          index: i,
          longitude: location[0],
          latitude: location[1],
          properties: {
            project: i,
            color: project.type.color === "#673AB7" ? 4 : 19
          }
        })
      )
    );
    return temp;
  }

  clickOnMarker(marker) {
    let temp = [marker.index];
    this.toggleSidepanel(temp);
  }

  clickOnCluster(cluster) {
    let temp = [];
    cluster.map(item => {
      temp.push(item.properties.project);
    });
    this.toggleSidepanel(temp);
  }

  clickOnViewButton(value) {
    this.toggleSidepanel([value]);
  }

  updateViewport(viewport) {
    this.setState({ viewport });
  }

  toggleSidepanel(value) {
    this.setState({ sidepanel: [] });
    if (value !== this.state.sidepanel) {
      this.setState({ sidepanel: value });
    }
  }

  render() {
    const markers = this.getMarkers();
    const { viewport } = this.state;
    return (
      <Component>
        <Shell data={this.state} />
        <Grid valign="expand">
          <Box>
            <div
              style={{
                position: "absolute",
                left: 15,
                top: 15,
                width: "calc(100% - 30px)",
                zIndex: 4
              }}
            >
              <Grid>
                <Box>
                  <Search placeholder="Search">
                    <b>23</b> documents
                  </Search>
                </Box>
                <Box width="150px" style={{ textAlign: "right" }}>
                  <ButtonGroup>
                    <Button circle>
                      <FontAwesomeIcon icon={faLibrary} />
                    </Button>
                    <Button circle success>
                      <FontAwesomeIcon icon={faMap} />
                    </Button>
                  </ButtonGroup>
                </Box>
              </Grid>
            </div>
            <Map
              latitude={25}
              longitude={0}
              zoom={2}
              height={window.innerHeight - 100}
              width={window.innerWidth - 400}
              {...viewport}
              onViewportChange={this.updateViewport.bind(this)}
              markers={markers}
              clickOnMarker={this.clickOnMarker}
              clickOnCluster={this.clickOnCluster}
              cluster
            />
            <Container>
              <Footer instance="Atlas of Torture" />
            </Container>
          </Box>
          <Sidepanel>
            {FILTERS.map((filter, i) => (
              <Filters title={filter.name} properties={filter.properties} />
            ))}
          </Sidepanel>
          {this.state.sidepanel.length > 0 ? (
            <Sidepanel floating>
              <Button
                onClick={() => this.toggleSidepanel([])}
                style={{ marginBottom: 32 }}
              >
                <FontAwesomeIcon icon={faClose} /> Close
              </Button>
              {this.state.sidepanel.length > 1 ? (
                <div>
                  <b>
                    <FontAwesomeIcon icon={faCheckSquare} />{" "}
                    {this.state.sidepanel.length} items
                  </b>
                  {this.state.sidepanel.map(
                    item =>
                      data.projects[item] ? (
                        <Item
                          compact
                          data={data.projects[item]}
                          clickOnViewButton={this.clickOnViewButton}
                          project={item}
                        />
                      ) : (
                        <div>NO ID</div>
                      )
                  )}
                </div>
              ) : (
                <Item valign="top" data={data.projects[this.state.sidepanel]} />
              )}
            </Sidepanel>
          ) : (
            ""
          )}
        </Grid>
      </Component>
    );
  }
}

const Component = styled.div``;

const Pin = styled(FontAwesomeIcon)`
  color: ${props =>
    props.type === "success"
      ? "#28a745"
      : props.type === "danger"
        ? "red"
        : "blue"};
  opacity: 0.9;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
`;



// WEBPACK FOOTER //
// ./src/Containers/AOT/Projects.js